import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const KEY = "cu-theme";

export const applyTheme = (t) => {
  document.documentElement.classList.toggle("dark", t === "dark");
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", t === "dark" ? "#070d1f" : "#1e40af");
};

export const ThemeToggle = () => {
  const [theme, setTheme] = useState(() => (document.documentElement.classList.contains("dark") ? "dark" : "light"));
  useEffect(() => {
    applyTheme(theme);
    localStorage.setItem(KEY, theme);
  }, [theme]);
  const dark = theme === "dark";
  return (
    <button onClick={() => setTheme(dark ? "light" : "dark")} data-testid="theme-toggle" aria-label={dark ? "Mode terang" : "Mode gelap"}
      className="p-2 rounded-full hover:bg-slate-100 transition-colors">
      {dark ? <Sun className="h-6 w-6 text-amber-400" /> : <Moon className="h-6 w-6 text-slate-700" />}
    </button>
  );
};
